import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from './layouts/layout.component';
import { AuthGuard } from './core/guards/auth.guard';
import { Page404Component } from './shared/components/page404/page404.component';
import { LoginGuard } from './core/guards/loginGuard';
import { PaymentSuccessComponent } from './features/payment-success/payment-success.component';
import { PaymentSmsComponent } from './features/payment-sms/payment-sms.component';
import { WhatsappfilesComponent } from './features/whatsappfiles/whatsappfiles.component';
import { RegistrationComponent } from './features/RegistrationGasLeak/registration/registration.component';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./core/auth/auth.module').then((m) => m.AuthModule),
    canActivate: [LoginGuard],
  },
  { path: 'paymentsuccess/callback', component: PaymentSuccessComponent },
  { path: 'files/:id/:type', component: WhatsappfilesComponent },
  { path: 'RIBSAP/pay/:code', component: PaymentSmsComponent }, //for sms triger
  { path: 'SmartLeakDevices/Registration', component: RegistrationComponent }, //for gas leak device registration

  {
    path: '',
    component: LayoutComponent,
    loadChildren: () =>
      import('./features/features.module').then((m) => m.FeaturesModule),
    canActivate: [AuthGuard],
  },
  { path: 'gas-leak-detector', loadChildren: () => import('./features/gas-leak-detector/gas-leak-detector.module').then(m => m.GasLeakDetectorModule) },

  { path: '**', component: Page404Component },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule],
})
export class AppRoutingModule {}
